import actionTypes from '../constants/action-types';

const setDomains = (domains) => ({
  type: actionTypes.SET_DOMAINS,
  payload: {
    domains,
  },
});

export default setDomains;
